import { Component, Vue, Prop } from 'vue-property-decorator'

import Loader from '@/components/Loader/index.vue'
import ModalTrial from '@/components/ModalTrial/index.vue'
import ModalTrialAdm from '@/components/ModalTrialAdm/index.vue'

import api from '@/helpers/fetch'
import tableHelper from '@/helpers/table'

import { library } from '@fortawesome/fontawesome-svg-core'

import { faClock, faLink } from '@fortawesome/free-solid-svg-icons'

library.add(faClock, faLink)

@Component({
	components: {
		Loader,
		ModalTrial,
		ModalTrialAdm,
	},
})
export default class ModalSubjectDependency extends Vue {
	@Prop({ required: true }) subject
	loading = true
	deleteLoading = false
	trials = [] as Array<any>
	trialsAdm = [] as Array<any>
	deadlines = [] as Array<any>
	selectedTrialId = 0

	async loadDependency() {
		this.loading = true
		await this.$nextTick()
		const res = await api.get('/api/subjects/dependency/' + this.subject.id)
		this.loading = false
		this.trials = res.data.trials
			.filter((trialMap) => {
				return trialMap.trial
			})
			.map((trialMap) => {
				return {
					id: trialMap.trial.id,
					cnj: trialMap.trial.cnj,
					groupName: trialMap.trial.groupsRelations[0].group.name,
				}
			})
		this.trialsAdm = res.data.trials
			.filter((trialMap) => {
				return trialMap.trialsAdm
			})
			.map((trialMap) => {
				return {
					id: trialMap.trialsAdm.id,
					processNumber: trialMap.trialsAdm.processNumber,
					groupName: trialMap.trialsAdm.groupsRelations[0].group.name,
				}
			})
		this.deadlines = res.data.deadlines.map((deadlineMap) => {
			return {
				cnj: deadlineMap.deadline.main_trial_cnj,
				fatalDate: deadlineMap.deadline.fatalDate,
			}
		})
	}

	openTrialDetail(id) {
		this.selectedTrialId = id
		this.$bvModal.show('modal-trial')
	}

	openTrialAdmDetail(id) {
		this.selectedTrialId = id
		this.$bvModal.show('modal-trial-adm')
	}

	formatCNJ(val) {
		return tableHelper.formatCNJ(val)
	}

	formatDate(d) {
		const [year, month, day] = d.split('-')

		return `${day}/${month}/${year}`
	}

	async deleteSubject(id) {
		this.deleteLoading = true
		const res = await api.delete('/api/subjects/', { id })
		this.deleteLoading = false
		if (res.ok) {
			this.$emit('deleted')
			this.showToast('Tese operacional excluída com sucesso!', 'success')
			this.$bvModal.hide('modal-subject-dependency')
		} else {
			this.showToast('Ocorreu um erro inesperado!', 'danger')
		}
	}

	showToast(msg, variant) {
		this.$bvToast.toast(msg, {
			title:
				variant === 'success'
					? 'Sucesso!'
					: variant === 'danger'
						? 'Erro!'
						: 'Alerta!',
			autoHideDelay: 2500,
			appendToast: true,
			variant,
			toaster: 'b-toaster-top-center',
			solid: true,
		})
	}
}
